// src/Components/CreateDatabaseQuestion/DatabaseQuestionList.js
import React, { useEffect, useState, useRef } from "react";
import '../CreateCodingQuestion/style.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector, useDispatch } from "react-redux";
import {
  resetDatabaseQuestions,
  getDatabaseQuestions,
  getNextDatabaseQuestions,
} from "../../Redux/ActionCreators/testLibraryAction";

export default function DatabaseQuestionList(props) {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const timerRef = useRef(null);

  const dispatch = useDispatch();
  const {
    loadingDatabaseQuestion,
    totalDatabase,
    databaseQuestionListResponse,
    selectedDatabaseQuestion,
  } = useSelector((state) => state.testLibrary);

  // ✅ Load first page
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dispatch(resetDatabaseQuestions());
    dispatch(getDatabaseQuestions(1, 20, props.testLevel, props.language, ""));
  }, [props.testLevel, props.language]);

  // ✅ Fetch next page (Infinite Scroll)
  const fetchData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    dispatch(
      getNextDatabaseQuestions(nextPage, 20, props.testLevel, props.language, query)
    );
  };

  // ✅ Select / Deselect question
  const selectQuestion = (e, el) => {
    dispatch({
      type: "SELECT_DATABASE_QUES",
      payload: { id: el.id, checked: e.target.checked, data: el },
    });
  };

  // ✅ Done button handler
  const selectDone = () => {
    props.saveSelectQuestion(selectedDatabaseQuestion);
  };

  // ✅ Debounced search input
  const searchQuestion = (val) => {
    clearTimeout(timerRef.current);
    setQuery(val);
    setPage(1);
    timerRef.current = setTimeout(() => delaySearch(val), 800);
  };

  // ✅ Perform search (clear + refetch)
  const delaySearch = (val) => {
    window.scrollTo({ top: 0 });
    dispatch(resetDatabaseQuestions());
    dispatch(getDatabaseQuestions(1, 20, props.testLevel, props.language, val));
  };

  return (
    <div className="coding-questions-list">
      <div className="question-list-header">
        <div className="d-flex justify-content-between align-items-center">
          <img
            src="/images/back.svg"
            alt=""
            className="cursor-pointer"
            onClick={props.backToAdd}
          />
          <h4>Add Database Question From List</h4>
          <button className="done-btn" onClick={selectDone}>
            DONE
          </button>
        </div>

        <div className="d-flex justify-content-between align-items-center flex-wrap mt-5">
          <div className="has-search">
            <span className="form-control-feedback">
              <img src="/images/search.svg" alt="" />
            </span>
            <input
              type="search"
              className="form-control"
              value={query}
              placeholder="Search for a question title"
              onChange={(e) => searchQuestion(e.target.value)}
            />
          </div>
          <h5>Selected Questions ({selectedDatabaseQuestion?.length || 0})</h5>
        </div>
      </div>

      <div
        id="scrollableDivDB"
        style={{
          maxHeight: window.innerWidth > 767 ? 350 : 510,
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        <InfiniteScroll
          dataLength={databaseQuestionListResponse?.length || 0}
          next={
            totalDatabase > databaseQuestionListResponse?.length
              ? fetchData
              : () => {}
          }
          hasMore={true}
          style={{ overflow: "unset" }}
          scrollableTarget="scrollableDivDB"
        >
          {loadingDatabaseQuestion ? (
            "Loading..."
          ) : databaseQuestionListResponse?.length > 0 ? (
            databaseQuestionListResponse.map((el, i) => (
              <div className="question-list" key={el.id}>
                <div>
                  <input
                    type="checkbox"
                    style={{ width: 16, height: 16 }}
                    value={el.id}
                    checked={!!el.isSelected}
                    onChange={(e) => selectQuestion(e, el)}
                  />
                </div>
                &nbsp;&nbsp;&nbsp;
                <div className="elipsis-2">{el.name}</div>
                <div>{el.difficultyLevelName}</div>
                <div>{el.duration} Mins</div>
                <div>Score: {el.score}</div>
              </div>
            ))
          ) : (
            <div className="empty-list">
              <img src="/images/magnifier.svg" alt="" />
              <div className="mt-2">
                <h3>No question found</h3>
              </div>
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
}